<template>
	<div id="mapdiv">
		<div id="map" ref="rootmap" name="olmap" class="map">
			<div class="layer-buttons">
				<img v-if="!dangerWorkShow" title="危险作业" src="../../assets/imgs/mapgis/wxzy.png" @click="getDangerWork(true)" />
				<img v-if="dangerWorkShow" title="危险作业" src="../../assets/imgs/mapgis/wxzy-active.png" @click="getDangerWork(false)" />
				<!-- <img v-if="!safeDangerShow" title="安全隐患" src="../../assets/imgs/mapgis/t_aqyh.png" @click="getSafeDanger()" />
				<img v-if="safeDangerShow" title="安全隐患" src="../../assets/imgs/mapgis/t_aqyh-active.png" @click="getSafeDanger()" />
				<img v-if="!jiujingCarShow" title="酒精车辆" src="../../assets/imgs/mapgis/t_jjcl.png" @click="getAllCar()" />
				<img v-if="jiujingCarShow" title="酒精车辆" src="../../assets/imgs/mapgis/t_jjcl-active.png" @click="getAllCar()" /> -->
				<img v-if="!onlineUserShow" title="人员定位" src="../../assets/imgs/mapgis/t_user.png" @click="getAllOnLineUser(true)" />
				<img v-if="onlineUserShow" title="人员定位" src="../../assets/imgs/mapgis/t_user-active.png" @click="getAllOnLineUser(false)" />
				<img v-if="!monitorShow" title="摄像头" src="../../assets/imgs/mapgis/t_sxt.png" @click="getAllSxtList()" />
				<img v-if="monitorShow" title="摄像头" src="../../assets/imgs/mapgis/t_sxt-active.png" @click="getAllSxtList()" />
				<!-- <img v-if="!aqmShow" title="安全帽" src="../../assets/imgs/mapgis/t_aqm.png" @click="getAqmList()" />
				<img v-if="aqmShow" title="安全帽" src="../../assets/imgs/mapgis/t_aqm-active.png" @click="getAqmList()" /> -->
				<img v-if="!aqmShow" title="移动执法记录仪" src="../../assets/imgs/mapgis/zfjly.png" @click="getAqmList()" />
				<img v-if="aqmShow" title="移动执法记录仪" src="../../assets/imgs/mapgis/zfjly-active.png" @click="getAqmList()" />
				<img :title="'回到厂区'" src="../../assets/imgs/mapgis/goback.png" @click="flyToFactory()" />
				<img :title="'我的位置'" src="../../assets/imgs/point1.png" @click="dingwei()" />
				<img :title="'清空'" src="../../assets/imgs/mapgis/marker-clear.png" @click="clear()" />

				<!-- <img :title="'危险作业'" src="../../assets/imgs/mapgis/donghuo.png" @click="getWorkNum(1)" /> -->
				<!-- <img :title="'吊装作业'" src="../../assets/imgs/mapgis/diaozhuang.png" @click="getWorkNum(2)" />
        <img :title="'高处作业'" src="../../assets/imgs/mapgis/gaochu.png" @click="getWorkNum(3)" />
        <img :title="'盲板作业'" src="../../assets/imgs/mapgis/mangban.png" @click="getWorkNum(4)" />
        <img :title="'动土作业'" src="../../assets/imgs/mapgis/dongtu.png" @click="getWorkNum(5)" />
        <img :title="'临时用电'" src="../../assets/imgs/mapgis/yongdian.png" @click="getWorkNum(6)" />
        <img :title="'受限空间'" src="../../assets/imgs/mapgis/shouxian.png" @click="getWorkNum(7)" />
        <img :title="'断路作业'" src="../../assets/imgs/mapgis/duanlu.png" @click="getWorkNum(8)" />
        <img :title="'维修作业'" src="../../assets/imgs/mapgis/weixiu.png" @click="getWorkNum(9)" /> -->
			</div>

		</div>
		<div id="info"></div>
		<div id="overlayinfo"></div>
	</div>
</template>
<script>
	import "ol/ol.css";
	import {
		Map,
		View
	} from "ol";
	import {
		defaults as defaultControls
	} from "ol/control.js";
	import XYZ from "ol/source/XYZ";
	import {
		TileArcGISRest
	} from 'ol/source';
	import {
		Tile as TileLayer
	} from "ol/layer";
	import VectorLayer from "ol/layer/Vector";
	import VectorSource from "ol/source/Vector";
	import Feature from "ol/Feature";
	import Style from "ol/style/Style";
	import Icon from "ol/style/Icon";
	import Text from "ol/style/Text";
	import Fill from "ol/style/Fill";
	import Stroke from "ol/style/Stroke";
	import {
		Circle,
		Geometry,
		LineString,
		MultiLineString,
		MultiPoint,
		MultiPolygon,
		Point,
		Polygon
	} from "ol/geom.js";

	import TileWMS from "ol/source/TileWMS";
	import {
		defaults as defaultInteractions
	} from "ol/interaction";
	import coordtranse from "./config/coordtranse.js";
	import donghuoImg from "@/assets/imgs/mapgis/RiskPoints4.png";
	import diaozhuangImg from "@/assets/imgs/mapgis/RiskPoints4.png";
	import gaochuImg from "@/assets/imgs/mapgis/RiskPoints4.png";
	import mangbanImg from "@/assets/imgs/mapgis/RiskPoints4.png";
	import dongtuImg from "@/assets/imgs/mapgis/RiskPoints1.png";
	import yongdianImg from "@/assets/imgs/mapgis/RiskPoints1.png";
	import shouxianImg from "@/assets/imgs/mapgis/RiskPoints2.png";
	import duanluImg from "@/assets/imgs/mapgis/RiskPoints2.png";
	import weixiuImg from "@/assets/imgs/mapgis/RiskPoints2.png";
	import workNumImg from "@/assets/imgs/mapgis/人员数量.png";
	import personRed from "@/assets/imgs/mapgis/personRed.png";
	import personBlue from "@/assets/imgs/mapgis/personBlue.png";
	import vehicleRed from "@/assets/imgs/mapgis/vehicleRed.png";
	import vehicleBlue from "@/assets/imgs/mapgis/vehicleBlue.png";
	import DGZYMarker from "@/assets/imgs/mapgis/zypic/高空.png";
	import DHZYMarker from "@/assets/imgs/mapgis/zypic/动火.png";
	import DLZYMarker from "@/assets/imgs/mapgis/zypic/断路.png";
	import DTZYMarker from "@/assets/imgs/mapgis/zypic/动土.png";
	import DZZYMarker from "@/assets/imgs/mapgis/zypic/吊装.png";
	import LSYDZYMarker from "@/assets/imgs/mapgis/zypic/临时用电.png";
	import MBCDMarker from "@/assets/imgs/mapgis/zypic/盲板抽堵.png";
	import SBJWXMarker from "@/assets/imgs/mapgis/zypic/设备检修.png";
	import SXKJMarker from "@/assets/imgs/mapgis/zypic/有限空间.png";
	import TCZYMarker from "@/assets/imgs/mapgis/zypic/断路.png";
    import XZZYMarker from "@/assets/imgs/mapgis/zypic/设备检修.png";
	import leaderMarker from '@/assets/imgs/mapgis/人员位置.png';
	import aqmMarker from '@/assets/imgs/mapgis/aqm.png';
	import jcCar from '@/assets/imgs/mapgis/a_car.gif';
	import jcChaosu from '@/assets/imgs/mapgis/a_chaosu.gif';
	import Overlay from "ol/Overlay";
	export default {
		props: {
			highRiskPosition: Array, //所有车辆位置信息
		},
		data() {
			return {
				overlay: null,
				map: null,
				view: null,
				donghuoL: null,
				diaozhuangL: null,
				gaochuL: null,
				mangbanL: null,
				dongtuL: null,
				yongdianL: null,
				shouxianL: null,
				duanluL: null,
				weixiuL: null,
				workNumL: null,
				factoryLineL: null,
				workUnitL:null,//工作单元区域
				riskAnalysisL: null, //风险分析图层
				personL: null, //展示人员图层
				vehicleL: null, //展示车辆图层
				dangerousOperationL: null, //展示危险作业图层
				leaderL: null,
				checkCarInfoL: null, //检测车辆信息图层
				checkUserInfoL: null, //检测人员行为分析信息图层
				jiujingCarL: null, //酒精车辆图层
				onLineUserL: null, //在线人员
				monitorL: null, //摄像头
				safeDangerL: null, //存在的安全隐患
				checkCarInfoData: null,
				carSdnum: 0,
				timer1: null,
				checkUserInfoData: null,
				userSdnum: 0,
				timer2: null,
				timerwxzys:null,
				timeryhdw:null,
				riskWorkPositionData: [],
				geoserverUrl: "https://117.14.55.74:18082/geoserver/",
				baseUrl: sessionStorage.getItem("baseURL"),
				risk1: false,
				risk2: false,
				risk3: false,
				risk4: false,
				dangerWorkShow: false,
				jiujingCarShow: false,
				onlineUserShow: false,
				monitorShow: false,
				aqmShow: false,
				safeDangerShow: false,
				factoryPersonShow: false,
				factoryCarShow: false,
				markers: {
					jiujingCar: require("@/assets/imgs/mapgis/jiujin.png"),
					shuaidao: require("@/assets/imgs/mapgis/摔倒.png"),
					wdaqm: require('@/assets/imgs/mapgis/未戴安全帽.png'),
					wsyaqs: require('@/assets/imgs/mapgis/未使用安全绳.png'),
					xiyan: require('@/assets/imgs/mapgis/吸烟.png'),
					ffrq: require('@/assets/imgs/mapgis/非法入侵.png'),
					jiujingCar: require('@/assets/imgs/mapgis/jiujin.png'),
					personImg: require('@/assets/imgs/mapgis/人员位置.png'),
					monitorImg: require("@/assets/imgs/mapgis/zypic/摄像头.png"),
					ybDangerImg: require("@/assets/imgs/mapgis/一般隐患.png"),
					zdDangerImg: require("@/assets/imgs/mapgis/重大隐患.png"),
				},
				userInfo:null,
				unitid:null,
				factoryPosition:[117.60648, 32.99656],
				zooms:15,
				factoriesName:'',
				plugin: [{
					pName: 'Geolocation',
					events: {
						init(o) {
							// o 是高德地图定位插件实例
							o.getCurrentPosition((status, result) => {
								if (result && result.position) {
									self.lngamap = result.position.lng;
									self.latamap = result.position.lat;
									self.center = [self.lngamap, self.latamap];
									self.loaded = true;
									self.$nextTick();
								}
							});
						}
					}
				}]
			};
		},
		created(){
			setTimeout(this.getDangerWorks, 1000);//默认显示危险作业
			this.userInfo = sessionStorage.getItem("userInfo");
			if(this.userInfo){
				let a = JSON.parse(this.userInfo);
				this.unitid = a.qyguid;
				let factoryPosition = [];
				if(a.longitude && a.latitude){
					factoryPosition.push(a.longitude*1);
					factoryPosition.push(a.latitude*1);
					this.factoryPosition = factoryPosition;
				}
			}
			this.factoriesName = (this.$route.params.GCMZ)?this.$route.params.GCMZ:sessionStorage.getItem('GCMZ')
		},
		mounted() {
			//
			this.$nextTick(()=>{
				this.getqyinfo(this.factoriesName);
			})
			
			
			// this.initMap();
			// this.riskAnalysisClick();
			this.changezoom()
		},
		beforeDestroy() {
			clearInterval(this.timerwxzys);
			clearInterval(this.timeryhdw);
		},
		methods: {
			changezoom(){
				let ZYHGSMZ=sessionStorage.getItem('ZYHGSMZ')
				if(ZYHGSMZ=="中粮粮谷"){
					this.zooms=16
				}if(ZYHGSMZ=="中粮可口可乐"){
					this.zooms=16.5
				}
			},
			getDangerWorks:function(){
				this.dangerWorkShow = true;
				this.getHighRiskPosition();
			},
			getqyinfo:function(qyname){
				let that = this;
				this.$axios.get("/user/qy/getQyByName?name="+qyname, {}).then(res => {
					let val = res.data.data;
					if(val){
						that.factoryPosition[0] = val.longitude*1;
						that.factoryPosition[1] = val.latitude*1;
						that.unitid = val.qyguid;
					}
					that.initMap();
					that.getAllUnitByqyid();
				});
			},
			getAllUnitByqyid() {
				let this_ = this;
				this.$axios.post('/user/workUnit/getWorkUnitListBydepartIdPagination', {
					qyid: this.unitid,
					departid: this.unitid
				}, {
					headers: {
						'Content-Type': 'application/json'
					},
				}).then((res) => {
					if (res.data.code == 1) {
						let list = res.data.data.rows; // 后台返回list
						for (var i = 0; i < list.length; i++) {
							let data = list[i];
							let mt = this.str2jwd(data); //多边形的坐标
							if(data.worktype == '2'){
								this.tobianjie(mt,data.color);
							}else{
								let l = this.hex2rgb(data.color, 1); //边框的颜色
								let f = this.hex2rgb(data.color, 0.3); //面积的颜色
								
								let pol = new Feature({
									geometry: new Polygon(mt),
								});
								pol.name = data.name;
								pol.setStyle(
									new Style({
										stroke: new Stroke({
											color: l,
											width: 2
										}),
										fill: new Fill({
											color: f
										})
									})
								);
								this.workUnitL.getSource().addFeature(pol);
							}
						}
					}
				})
			},
			//虚线多边形
			tobianjie:function(mt,color){
				let factoryLine = new Feature(
				  new LineString(mt[0])
				);
				factoryLine.setStyle(
					new Style({
					  stroke: new Stroke({
						color: color, // 颜色
						width: 3, // 宽度
						lineDash: [12, 6], // 虚线
					  }),
					})
				)
				this.factoryLineL.getSource().addFeature(factoryLine);
			},
			//字符串转换成坐标
			str2jwd: function(data) {
				let dbx = [];
				if (data.position) {
					let jwds = data.position.split(','); //分隔每个坐标
					for (var i = 0; i < jwds.length; i++) {
						var jwd = jwds[i];
						let jdwd = jwd.split(':');
						jdwd[0] = jdwd[0] * 1;
						jdwd[1] = jdwd[1] * 1;
						dbx.push(jdwd);
					}
				}
				let mt = [];
				mt.push(dbx);
				return mt;
			},
			//将16进制颜色转换成rgb
			hex2rgb: function(a, tm) {
				a = a.substring(1);
				a = a.toLowerCase();
				let b = new Array();
				for (var x = 0; x < 3; x++) {
					b[0] = a.substr(x * 2, 2);
					b[3] = "0123456789abcdef";
					b[1] = b[0].substr(0, 1);
					b[2] = b[0].substr(1, 1);
					b[20 + x] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
				}
				return "rgb(" + b[20] + "," + b[21] + "," + b[22] + "," + tm + ")";
			},
			//回到我的位置
			dingwei:function(){
			  try {
				  let location = Android.getLocation();
				  let jwd = location.split(',');
				  this.j = parseFloat(jwd[0].substring(3));
				  this.w = parseFloat(jwd[1].substring(3));
			  } catch (err) {
				  if(this.lngamap&&this.latamap){
					this.j = this.lngamap
					this.w = this.latamap
				  }else{
					[this.j, this.w] = this.factoryPosition
				  }
			  }
			  this.view.animate({
				center: [this.j, this.w],
				duration: 800,
				zoom: 15
			  });
			},
			flyToFactory: function() {
				this.view.animate({
					center: this.factoryPosition,
					duration: 800,
					zoom: 15
				});
			},
			initMap: function() { //加载地图
				let _this = this;
				this.overlay = new Overlay({
        element: document.getElementById("overlayinfo"),
        autoPan: false, // 定义弹出窗口在边缘点击时候可能不完整 设置自动平移效果
        autoPanAnimation: {
          duration: 250, //自动平移效果的动画时间 9毫秒）
        },
        offset: [0, -10],
        positioning: "bottom-center",
      });
				/** 地图容器 */
				var mapcontainer = this.$refs.rootmap;
				this.view = new View({
					center: _this.factoryPosition,
					projection: "EPSG:4326",
					zoom: _this.zooms,
					minZoom: 5,
					maxZoom: 20
				});
				let arcgisMapLayer = new TileLayer({
					// extent: [-13884991, 2870341, -7455066, 6338219],
					source: new TileArcGISRest({
						url: 'https://cache1.arcgisonline.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer'
					})
				})
				let googleMapLayer = new TileLayer({
					source:
						// 天地图影像
						new XYZ({
							tileUrlFunction: function (tileCoord) {
								if (tileCoord) {
									const z = tileCoord[0];
									const x = tileCoord[1];
									const y = tileCoord[2];
									return "https://t" + (x % 7) + ".tianditu.gov.cn/DataServer?T=img_w&" + "x=" + x + "&" + "y=" + y + "&" + "l=" + z + "&" + "tk=" + "d10a1eedc59b78afc3df23e2ef9f1ecd";
								} else {
									return '';
								}
							}
						})
				});
				let wmsSource =
					// new TileWMS({
					//   url: this.geoserverUrl + "zlsw/wms",
					//   params: { LAYERS: "zlsh:zlsh_factory", TILED: true },
					//   serverType: "geoserver",
					//   crossOrigin: "anonymous"
					// });
					new TileWMS({
						ratio: 1,
						url: this.geoserverUrl + "zlsw/wms",
						params: {
							'FORMAT': 'image/png',
							'VERSION': '1.1.1',
							STYLES: '',
							LAYERS: 'zlsw:zlsw',
						}
					})
				let factoryL = new TileLayer({
					source: wmsSource
				}); //区域图层
				this.factoryLineL = new VectorLayer({
					source: new VectorSource(),
					name: "factoryLineL",
					id: "factoryLineL"
				}); //厂区位置
				//================================================点击下边图表时触发的事件所需图层=====================================
				this.workUnitL = new VectorLayer({
					source: new VectorSource(),
					name: "workUnitL",
					id: "workUnitL"
				}); //风险分析展示图层
				this.riskAnalysisL = new VectorLayer({
					source: new VectorSource(),
					name: "riskAnalysisL",
					id: "riskAnalysisL"
				}); //风险分析展示图层
				this.personL = new VectorLayer({
					source: new VectorSource(),
					name: "personL",
					id: "personL"
				}); //人员展示图层
				this.vehicleL = new VectorLayer({
					source: new VectorSource(),
					name: "vehicleL",
					id: "vehicleL"
				}); //车辆展示图层
				this.dangerousOperationL = new VectorLayer({
					source: new VectorSource(),
					name: "dangerousOperationL",
					id: "dangerousOperationL"
				}); //危险作业图层
				this.leaderL = new VectorLayer({
					source: new VectorSource(),
					name: "leaderL",
					id: "leaderL"
				}); //带班领导位置
				this.checkCarInfoL = new VectorLayer({
					source: new VectorSource(),
					name: "checkCarInfoL",
					id: "checkCarInfoL"
				}); //检测车辆信息图层
				this.checkUserInfoL = new VectorLayer({
					source: new VectorSource(),
					name: "checkUserInfoL",
					id: "checkUserInfoL"
				}); //检测行为分析信息图层
				this.jiujingCarL = new VectorLayer({
					source: new VectorSource(),
					name: "jiujingCarL",
					id: "jiujingCarL"
				}); //酒精车辆图层
				this.onLineUserL = new VectorLayer({
					source: new VectorSource(),
					name: "onLineUserL",
					id: "onLineUserL"
				}); //在线人员图层
				this.monitorL = new VectorLayer({
					source: new VectorSource(),
					name: "monitorL",
					id: "monitorL"
				}); //摄像头图层
				this.safeDangerL = new VectorLayer({
					source: new VectorSource(),
					name: "safeDangerL",
					id: "safeDangerL"
				}); //隐患图层
				//==================================================================================================================
				this.donghuoL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: donghuoImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "donghuoL",
					id: "donghuoL"
				}); //动火作业图层
				this.diaozhuangL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: diaozhuangImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "diaozhuangL",
					id: "diaozhuangL"
				}); //吊装作业图层
				this.gaochuL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: gaochuImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "gaochuL",
					id: "gaochuL"
				}); //高处作业图层
				this.mangbanL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: mangbanImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "mangbanL",
					id: "mangbanL"
				}); //盲板作业图层
				this.dongtuL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: dongtuImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "dongtuL",
					id: "dongtuL"
				}); //动土作业图层
				this.yongdianL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: yongdianImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "yongdianL",
					id: "yongdianL"
				}); //临时用电作业图层
				this.shouxianL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: shouxianImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "shouxianL",
					id: "shouxianL"
				}); //受限空间作业图层
				this.duanluL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: duanluImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "duanluL",
					id: "duanluL"
				}); //断路作业图层
				this.weixiuL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: weixiuImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "weixiuL",
					id: "weixiuL"
				}); //动火作业图层
				this.workNumL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: workNumImg,
								anchor: [0.5, 1]
							})
						});
					},
					name: "workNumL",
					id: "workNumL"
				}); //作业数量图层
				this.aqmNumL = new VectorLayer({
					source: new VectorSource(),
					style: function(f, r) {
						return new Style({
							image: new Icon({
								src: aqmMarker,
								anchor: [0.5, 1]
							})
						});
					},
					name: "aqmNumL",
					id: "aqmNumL"
				}); //安全帽图层
				let layerArr = [];
				layerArr = [googleMapLayer, this.factoryLineL,this.workUnitL, this.aqmNumL, this.donghuoL, this.diaozhuangL, this.gaochuL, this.mangbanL,
					this.dongtuL, this.yongdianL, this.shouxianL, this.duanluL, this.weixiuL, this.workNumL,
					this.riskAnalysisL, this.personL, this.vehicleL, this.dangerousOperationL, this.leaderL, this.checkCarInfoL,
					this.checkUserInfoL,
					this.jiujingCarL, this.onLineUserL, this.monitorL, this.safeDangerL
				]; // factoryL,factoryLineL,
				this.map = new Map({
					target: mapcontainer,
					controls: defaultControls({
						attribution: false,
						zoom: false
					}).extend(
						[]
					),
					interactions: defaultInteractions({
						doubleClickZoom: false,
						mouseWheelZoom: true,
						shiftDragZoom: false,
						dragPan: true,
						altShiftDragRotate: false,
						pinchZoom: true
					}),
					layers: layerArr,
					view: this.view
				});
				let layerId;
				this.map.addOverlay(this.overlay);
				this.map.on("singleclick", function(evt) {
					let coordinate = evt.coordinate;
					var feature = _this.map.forEachFeatureAtPixel( //这里获取到鼠标点击像素的feature
						evt.pixel,
						function(feature) {
							return feature;
						}, {
							layerFilter: function(ly) {
								layerId = ly.getProperties().id; //这里得到鼠标点击的feature所在的layer的id
								return true;
							}
						}
					);
					if (feature) {
						if (layerId == 'aqmNumL') { //判断feature所在的layer的id
							_this.$emit("getPlay", feature);
						} else if (layerId == 'monitorL') {
							_this.$emit("getMonitorIndex", feature);
						} else if (layerId == 'dangerousOperationL') { //危险作业
							_this.$emit("jumpToRiskPage", feature);
						}else if (layerId == 'workUnitL') {
						 $("#overlayinfo").html(feature.name);
             _this.overlay.setPosition(coordinate);
						}
					}else {
          _this.overlay.setPosition(null);
          //document.getElementById("mapdiv").style.cursor = "auto";
        } 
				});

				this.map.on("pointermove", function(e) {
					var feature = _this.map.forEachFeatureAtPixel(e.pixel, function(feature, layer) {
						return feature;
					});
					if (feature) {
						document.getElementById("mapdiv").style.cursor = "pointer";
					} else {
						document.getElementById("mapdiv").style.cursor = "auto";
					}
				});
			},
			toVehicleInformation: function() {
				let _this = this;
				//_this.$emit("toVehicleInformation");//点击点触发，调用父页面
			},
			clear: function() { //清空地图上全部的要素
				this.workNumL.getSource().clear();
				this.riskAnalysisL.getSource().clear();
				this.personL.getSource().clear();
				this.vehicleL.getSource().clear();
				this.dangerousOperationL.getSource().clear();
				this.jiujingCarL.getSource().clear();
				this.onLineUserL.getSource().clear();
				this.monitorL.getSource().clear();
				this.safeDangerL.getSource().clear();
				this.risk1 = false;
				this.risk2 = false;
				this.risk3 = false;
				this.risk4 = false;
				this.dangerWorkShow = false;
				this.jiujingCarShow = false;
				this.onlineUserShow = false;
				this.monitorShow = false;
				this.safeDangerShow = false;
				this.factoryPersonShow = false;
				this.factoryCarShow = false;
			},
			//存在的隐患，已整改完成的就不是隐患了
			getSafeDanger: function() {
				let _this = this;
				this.safeDangerShow = !this.safeDangerShow;
				if (this.safeDangerShow) {
					this.$axios.get("/danger/dangerinfo/getProceedHiddendDanger", {}).then(res => {
						let val = res.data.data.data;
						let monitorPosition = [];
						_this.safeDangerL.getSource().clear();
						for (let item of val) {
							monitorPosition = [item.longitude, item.latitude];
							let f = new Feature(new Point(monitorPosition));
							let src = null;
							if (item.dangerLevel == '一般隐患') {
								src = _this.markers.ybDangerImg;
							} else {
								src = _this.markers.zdDangerImg;
							}
							f.setStyle(
								new Style({
									image: new Icon({
										src: src,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: item.description,
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								}));
							_this.safeDangerL.getSource().addFeature(f);
						}
					});
				} else {
					_this.safeDangerL.getSource().clear();
				}
			},
			//获得摄像头
			getAllSxtList: function() {
				let _this = this;
				this.monitorShow = !this.monitorShow;
				if (this.monitorShow) {
					_this.$axios.post('/dform/sxt/getSxtList', {unitid:_this.unitid}, {
						headers: {
							'Content-Type': 'application/json'
						}
					}).then((res) => {
						let val = res.data.data.rows;
						let monitorPosition = [];
						_this.monitorL.getSource().clear();
						for (let item of val) {
							if (item.signaltype == '1') {
								monitorPosition = [item.longitude, item.latitude];
								let f = new Feature(new Point(monitorPosition));
								//f.setId(item.monitorcode);
								f.setId(item.id);
								let src = _this.markers.monitorImg;
								f.setStyle(
									new Style({
										image: new Icon({
											src: src,
											anchor: [0.5, 1]
										}),
										text: new Text({ //文本样式
											//text: item.sxtname,
											fill: new Fill({
												color: '#424242'
											}),
											stroke: new Stroke({
												color: '#fff',
												width: 3
											}),
											offsetY: 10,
											offsetX: 0,
										})
									}));
								_this.monitorL.getSource().addFeature(f);
							}
						}
					});
				} else {
					_this.monitorL.getSource().clear();
				}

			},
			//全部在线人员
			getAllOnLineUser: function(dw) {
				let _this = this;
				this.onlineUserShow = dw;
				if(this.onlineUserShow){
					this.getAllPersonPosition();
					this.timeryhdw = setInterval(this.getAllPersonPosition,30000);//默认显示危险作业
				}else{
					this.onLineUserL.getSource().clear();
					clearInterval(this.timeryhdw);
				}
			},
			getAllPersonPosition:function(){
				let _this = this;
				this.$axios.post("/user/PersonPathManage/getAllPersonPosition", {
					name: _this.factoriesName,
				}).then(data => {
					_this.onLineUserPosition(data.data.data.rows);
				});
			},
			onLineUserPosition: function(val) {
				if (this.onlineUserShow) {
					this.onLineUserL.getSource().clear();
					for (let item of val) {
						let onLineUserPosition = [item.lon, item.lat];
						// let a = coordtranse.bd09togcj02(item.lon, item.lat);
						// let onLineUserPosition = coordtranse.gcj02towgs84(a[0],a[1]);
						let f = new Feature(new Point(onLineUserPosition));
						let src = this.markers.personImg;
						f.setId(item.carCode);
						f.setStyle(
							new Style({
								image: new Icon({
									src: src,
									anchor: [0.5, 1]
								}),
								text: new Text({ //文本样式
									text: item.name,
									fill: new Fill({
										color: '#424242'
									}),
									stroke: new Stroke({
										color: '#fff',
										width: 3
									}),
									offsetY: 10,
									offsetX: 0,
								})
							}));
						this.onLineUserL.getSource().addFeature(f);
					}
				} else {
					this.onLineUserL.getSource().clear();
				}
			},
			//全部酒精车辆
			getAllCar: function() {
				let _this = this;
				this.$axios.get("/dform/VehiclePathManage/getAllVehicle", {}).then(data => {
					_this.jiujingCarPosition(data.data.data.rows);

				});
			},
			jiujingCarPosition: function(val) {
				this.jiujingCarShow = !this.jiujingCarShow;
				if (this.jiujingCarShow) {
					for (let item of val) {
						let vehiclePosition = [item.lon, item.lat];
						let f = new Feature(new Point(vehiclePosition));
						let src = this.markers.jiujingCar;
						f.setId(item.carCode);
						f.setStyle(
							new Style({
								image: new Icon({
									src: src,
									anchor: [0.5, 1]
								}),
								text: new Text({ //文本样式
									text: item.carCode,
									fill: new Fill({
										color: '#424242'
									}),
									stroke: new Stroke({
										color: '#fff',
										width: 3
									}),
									offsetY: 10,
									offsetX: 0,
								})
							}));
						this.jiujingCarL.getSource().addFeature(f);
					}
					this.view.animate({
						center: this.factoryPosition,
						duration: 800,
						zoom: 8
					});
				} else {
					this.jiujingCarL.getSource().clear();
					this.view.animate({
						center: this.factoryPosition,
						duration: 800,
						zoom: 16
					});
				}
			},
			getDangerWork: function(dw) {
				let that = this;
				that.dangerWorkShow = dw;
				if(that.dangerWorkShow){
					that.getHighRiskPosition();
					clearInterval(that.timerwxzys);
					that.timerwxzys = setInterval(that.getHighRiskPosition,30000);//默认显示危险作业
				}else{
					that.dangerousOperationL.getSource().clear();
					clearInterval(that.timerwxzys);
				}
				
			},
			getHighRiskPosition(){
				this.$axios.post('/dform/index/getHighRiskPosition', {
					gcid: this.unitid,
					cyllx:sessionStorage.getItem("rootDept")
				}).then(res => {
					if (res.data.code == 1) {
						this.threeTaskClick(res.data.data);
					}
				})
			},
			getWorkNum: function(val) {
				var type = '';
				if (val == 1) {
					//this.donghuoL.getSource().clear();//动火
					type = 'DHZY';
				} else if (val == 2) { //吊装
					type = 'YXKJZY';
				} else if (val == 3) { //高处
					type = 'GCZY';
				} else if (val == 4) { //盲板
					type = 'LSYDZY';
				} else if (val == 5) { //动土
					//this.dongtuL.getSource().clear();
					type = 'RISK_WORK_TYPE_DTZY';
				} else if (val == 6) { //临时用电
					type = 'LSYDZY';
				} else if (val == 7) { //受限空间
					//this.shouxianL.getSource().clear();
					type = 'YXKJZY';
				} else if (val == 8) { //断路
					type = 'RISK_WORK_TYPE_DLZY';
				} else if (val == 9) { //维修作业
					type = 'RISK_WORK_TYPE_SBJWXZY';
				}
				this.$axios.post('/highRisk/riskWorkStatistics/getHighRiskWorkNum', {
					//type: type
				}, {
					headers: {
						'Content-Type': 'application/json'
					}
				}).then((res) => {
					if (res.data.code == 1) {
						let workNum = res.data.data.workNum;
						this.workNumL.getSource().clear();
						for (let item of workNum) {
							if (item.longitude && item.latitude) {
								let riskWoekPosition = [item.longitude, item.latitude];
								let f = new Feature(new Point(riskWoekPosition));
								f.setStyle(
									new Style({
										image: new Icon({
											src: workNumImg,
											anchor: [0.5, 1]
										}),
										text: new Text({ //文本样式
											text: item.num + '',
											fill: new Fill({
												color: '#fff'
											}),
											// font:"bold 14px Times New Roman",
											// stroke: new Stroke({
											//     color: '#fff',
											//     width: 3
											// }),
											offsetY: -17,
											offsetX: 0,
										})
									}));
								this.workNumL.getSource().addFeature(f);
							}

						}
					} else {
						this.$layer.msg('网络异常');
					}

				})

			},
			getAqmList: function() {
				this.aqmShow = !this.aqmShow;
			},
			getAllAqmList: function(items) {
				let _this = this;
				let monitorPosition = [];
				_this.aqmNumL.getSource().clear();
				for (let item of items) {
					monitorPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(monitorPosition));
					var id = item.deviceId + ',' + item.userId;
					f.setId(id);
					f.setStyle(
						new Style({
							image: new Icon({
								src: aqmMarker,
								anchor: [0.5, 1]
							}),
							text: new Text({ //文本样式
								text: item.userName,
								fill: new Fill({
									color: '#424242'
								}),
								stroke: new Stroke({
									color: '#fff',
									width: 3
								}),
								offsetY: 10,
								offsetX: 0,
							})
						}));
					_this.aqmNumL.getSource().addFeature(f);
				}
			},
			riskWorkPosition: function(val) {
				this.riskWorkPositionData = val;
				//动火作业
				let donghuo = val.DHZY;
				this.donghuoL.getSource().clear();
				for (let item of donghuo) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.donghuoL.getSource().addFeature(f);
				}
				//吊装作业
				let diaozhuang = val.DZZY;
				this.diaozhuangL.getSource().clear();
				for (let item of diaozhuang) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.diaozhuangL.getSource().addFeature(f);
				}
				//高处作业
				let gaochu = val.GCZY;
				this.gaochuL.getSource().clear();
				for (let item of gaochu) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.gaochuL.getSource().addFeature(f);
				}
				//盲板抽堵作业
				let mangban = val.MBCDZY;
				this.mangbanL.getSource().clear();
				for (let item of mangban) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.mangbanL.getSource().addFeature(f);
				}
				//动土作业
				let dongtu = val.DTZY;
				this.dongtuL.getSource().clear();
				for (let item of dongtu) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.dongtuL.getSource().addFeature(f);
				}
				//临时用电作业
				let yongdian = val.LSYDZY;
				this.yongdianL.getSource().clear();
				for (let item of yongdian) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.yongdianL.getSource().addFeature(f);
				}
				//受限空间作业
				let shouxian = val.YXKJZY;
				this.shouxianL.getSource().clear();
				for (let item of shouxian) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.shouxianL.getSource().addFeature(f);
				}
				//断路作业
				let duanlu = val.DLZY;
				this.duanluL.getSource().clear();
				for (let item of duanlu) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.duanluL.getSource().addFeature(f);
				}
				//维修作业
				let weixiu = val.JWXZY;
				this.weixiuL.getSource().clear();
				for (let item of weixiu) {
					let riskWoekPosition = [item.longitude, item.latitude];
					let f = new Feature(new Point(riskWoekPosition));
					this.weixiuL.getSource().addFeature(f);
				}
			},
			riskAnalysisClick: function(data) { //大屏页面点击点击风险分析触发
				this.riskAnalysisL.getSource().clear();
				let f1 = new Feature({
					geometry: new Polygon([
						[
							[117.60607444681227, 32.99810707569122],
							[117.60713660158217, 32.99810707569122],
							[117.60713660158217, 32.99725949764252],
							[117.60607444681227, 32.99726486206055],
							[117.60607444681227, 32.99810707569122]
						],
						[
							[117.60626220144331, 32.99696981906891],
							[117.60682010091841, 32.99696981906891],
							[117.60682010091841, 32.99657285213475],
							[117.60626220144331, 32.99657285213475],
							[117.60626220144331, 32.99696981906891]
						],
						[
							[117.60505985934287, 32.99567967653274],
							[117.60585915762931, 32.99567967653274],
							[117.60585379321128, 32.99526125192642],
							[117.60505985934287, 32.99526393413544],
							[117.60505985934287, 32.99567967653274]
						]
					]),
				});
				f1.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(255,0,0, 0.4)'
						}),
						stroke: new Stroke({
							color: 'rgba(255,0,0, 0.8)',
							width: 2
						}),

					})
				);
				let f2 = new Feature({
					geometry: new Polygon([
						[
							[117.60124253109097, 32.99871325492859],
							[117.60191844776273, 32.99871325492859],
							[117.60185407474637, 32.99728631973266],
							[117.60124253109097, 32.99730777740478],
							[117.60124253109097, 32.99871325492859]
						],
						[
							[117.60305570438504, 32.99693226814277],
							[117.60572718456388, 32.99693226814277],
							[117.60570572689176, 32.99599885940552],
							[117.60491179302335, 32.9959774017334],
							[117.60487960651517, 32.995280027389526],
							[117.60305570438504, 32.99533367156982],
							[117.60305570438504, 32.99693226814277]
						],
						[
							[117.60221885517241, 32.99505472183227],
							[117.60369943454863, 32.99505472183227],
							[117.60367797687651, 32.9941427707672],
							[117.60294841602446, 32.99411058425903],
							[117.60295914486052, 32.993799448013306],
							[117.60221885517241, 32.993788719177246],
							[117.60221885517241, 32.99505472183227]
						],
						[
							[117.6062782946974, 32.996304631233215],
							[117.60686301626265, 32.996304631233215],
							[117.60688447393477, 32.99467384815216],
							[117.6062782946974, 32.99467384815216],
							[117.6062782946974, 32.996304631233215]
						],
						[
							[117.60899465996772, 32.99570381641388],
							[117.60909390170127, 32.99570381641388],
							[117.60908853728324, 32.99556165933609],
							[117.60899465996772, 32.99556702375412],
							[117.60899465996772, 32.99570381641388]
						],
						[
							[117.60902487672865, 32.99519956111908],
							[117.60945403017104, 32.99519956111908],
							[117.60945939458907, 32.99473285675049],
							[117.60902487672865, 32.99473285675049],
							[117.60902487672865, 32.99519956111908]
						],
						[
							[117.61024259962142, 32.99570381641388],
							[117.61216842569411, 32.99570381641388],
							[117.61214696802199, 32.994335889816284],
							[117.61024259962142, 32.99436807632446],
							[117.61024259962142, 32.99570381641388]
						],
						[
							[117.61239909566939, 32.99569845199586],
							[117.61325740255415, 32.99569845199586],
							[117.61325740255415, 32.99495279788972],
							[117.61239909566939, 32.994974255561836],
							[117.61239909566939, 32.99569845199586]
						]
					]),
				});
				f2.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(255,165,0, 0.4)'
						}),
						stroke: new Stroke({
							color: 'rgba(255,165,0, 0.8)',
							width: 2
						}),

					})
				);
				let f3 = new Feature({
					geometry: new Polygon([
						[
							[117.60338687337935, 32.99861669540405],
							[117.60374092496932, 32.99861669540405],
							[117.60373019613326, 32.99791395664215],
							[117.60386967100203, 32.99790322780609],
							[117.60385894216597, 32.99720048904419],
							[117.60373019613326, 32.99719512462616],
							[117.60372483171523, 32.99762427806854],
							[117.60338687337935, 32.99762964248657],
							[117.60338687337935, 32.99861669540405]
						],
						[
							[117.60576867498457, 32.99890637397766],
							[117.60713660158217, 32.99890637397766],
							[117.60712587274611, 32.998332381248474],
							[117.60575794614851, 32.998337745666504],
							[117.60576867498457, 32.99890637397766]
						],
						[
							[117.60120891965926, 32.997061014175415],
							[117.6028557959944, 32.997061014175415],
							[117.60286116041243, 32.996031045913696],
							[117.60244810022414, 32.99602568149567],
							[117.60243737138808, 32.9959237575531],
							[117.60120891965926, 32.99595594406128],
							[117.60120891965926, 32.997061014175415]
						],
						[
							[117.60820948518813, 32.9951673746109],
							[117.60901951231062, 32.9951673746109],
							[117.60902487672865, 32.99494743347168],
							[117.60820948518813, 32.99495279788971],
							[117.60820948518813, 32.9951673746109]
						],
						[
							[117.60739945806563, 32.9945182800293],
							[117.60839187540114, 32.9945182800293],
							[117.60837578214705, 32.99437344074249],
							[117.60905706323683, 32.99436271190643],
							[117.6090516988188, 32.99375116825104],
							[117.60739945806563, 32.9937618970871],
							[117.60739945806563, 32.9945182800293]
						]
					]),
				});
				f3.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(255,255,0, 0.4)'
						}),
						stroke: new Stroke({
							color: 'rgba(255,255,0, 0.8)',
							width: 2
						}),

					})
				);
				let f4 = new Feature({
					geometry: new Polygon([
						[
							[117.60212229564787, 32.99864888191223],
							[117.60327028110625, 32.99864888191223],
							[117.60324882343413, 32.997575998306274],
							[117.60371016338469, 32.997565269470215],
							[117.60371016338469, 32.99724340438843],
							[117.60212229564787, 32.99726486206055],
							[117.60212229564787, 32.99864888191223]
						],
						[
							[117.6039179507643, 32.99788177013397],
							[117.6044758502394, 32.99788177013397],
							[117.60449194349349, 32.99861669540405],
							[117.60539853014052, 32.998595237731934],
							[117.60539853014052, 32.9984986782074],
							[117.60464751161635, 32.99850404262543],
							[117.60464214719832, 32.99725413322449],
							[117.6039179507643, 32.99724876880646],
							[117.6039179507643, 32.99788177013397]
						],
						[
							[117.60733935981989, 32.999045848846436],
							[117.61349771171808, 32.999045848846436],
							[117.61349771171808, 32.9959774017334],
							[117.60733935981989, 32.9959774017334],
							[117.60733935981989, 32.999045848846436]
						],
						[
							[117.60119961574674, 32.99585938453674],
							[117.60292695835233, 32.99585938453674],
							[117.60290550068021, 32.99524784088135],
							[117.6020042784512, 32.99521565437317],
							[117.6020042784512, 32.99400329589844],
							[117.6017682440579, 32.9940140247345],
							[117.60180043056607, 32.995580434799194],
							[117.60119961574674, 32.995591163635254],
							[117.60119961574674, 32.99585938453674]
						],
						[
							[117.60391401126981, 32.99494743347168],
							[117.60594176128507, 32.99494743347168],
							[117.60595249012113, 32.994593381881714],
							[117.60716484859586, 32.994582653045654],
							[117.60716484859586, 32.99373507499695],
							[117.60391401126981, 32.99374580383301],
							[117.60391401126981, 32.99494743347168]
						],
						[
							[117.60737942531705, 32.99493670463562],
							[117.60870980098844, 32.99493670463562],
							[117.60870980098844, 32.99462556838989],
							[117.60737942531705, 32.99463629722595],
							[117.60737942531705, 32.99493670463562]
						],
						[
							[117.60957401711494, 32.99517273902893],
							[117.60972422081977, 32.99517273902893],
							[117.60972153861076, 32.994724810123444],
							[117.60957401711494, 32.99472749233246],
							[117.60957401711494, 32.99517273902893]
						],
						[
							[117.60973226744682, 32.99433588981629],
							[117.61037063319236, 32.99433588981629],
							[117.61036258656532, 32.99376994371415],
							[117.60973226744682, 32.99381017684937],
							[117.60973226744682, 32.99433588981629]
						],
						[
							[117.61238836683333, 32.99490988254547],
							[117.61324130930007, 32.99490988254547],
							[117.61320375837386, 32.99375653266907],
							[117.61238836683333, 32.993788719177246],
							[117.61238836683333, 32.99490988254547]
						]
					]),
				});
				f4.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(116,174,251, 0.4)'
						}),
						stroke: new Stroke({
							color: 'rgba(116,174,251, 0.8)',
							width: 2
						}),

					})
				);
				switch (data) {
					case '一级':
						this.risk1 = !this.risk1;
						break;
					case '二级':
						this.risk2 = !this.risk2;
						break;
					case '三级':
						this.risk3 = !this.risk3;
						break;
					case '四级':
						this.risk4 = !this.risk4;
				}
				if (this.risk1) {
					this.riskAnalysisL.getSource().addFeature(f1);
				}
				if (this.risk2) {
					this.riskAnalysisL.getSource().addFeature(f2);
				}
				if (this.risk3) {
					this.riskAnalysisL.getSource().addFeature(f3);
				}
				if (this.risk4) {
					this.riskAnalysisL.getSource().addFeature(f4);
				}
			},
			violationControlClick: function(data) { //大屏页面点击三违治理触发
			},
			dangerControlClick: function(data) { //大屏页面点击隐患治理触发
			},
			threeTaskClick: function(data) { //大屏页面点击三类作业触发
				let that = this;
				if (that.dangerWorkShow) {
					that.dangerousOperationL.getSource().clear();
					for (let i of data.GCZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",GCZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: DGZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.DHZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",DHZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: DHZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.DLZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",DLZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: DLZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.DTZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",DTZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: DTZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.DZZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",DZZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: DZZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.LSYDZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",LSYDZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: LSYDZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.MBCDZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",MBCDZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: MBCDMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.JWXZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",JWXZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: SBJWXMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
					for (let i of data.TCZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",YXKJZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: SXKJMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
										for (let i of data.TCZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",TCZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: TCZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
				    for (let i of data.XZZY) {
						if (i.longitude && i.latitude) {
							let f = new Feature({
								geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
							});
							f.setId(i.id + ",XZZY")
							f.setStyle(
								new Style({
									image: new Icon({
										src: XZZYMarker,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.departName ? i.departName : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.dangerousOperationL.getSource().addFeature(f);
						}
					}
				} else {
					this.dangerousOperationL.getSource().clear();
				}
			},
			personClick: function(data) { //大屏页面点击场内人员触发
				this.factoryPersonShow = !this.factoryPersonShow;
				if (this.factoryPersonShow) {
					if (data.type == '自有人数') {
						for (let i of data.data.zyry) {
							let m = coordtranse.wgs84togcj02(i.longitude, i.latitude);
							//geometry: new Point([parseFloat(i.longitude),parseFloat(i.latitude)]),
							let f = new Feature({
								geometry: new Point(m),
							});
							f.setStyle(
								new Style({
									image: new Icon({
										src: personRed,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.name ? i.name : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.personL.getSource().addFeature(f);
						}
					} else {
						for (let i of data.data.xgf) {
							let m = coordtranse.wgs84togcj02(i.longitude, i.latitude);
							let f = new Feature({
								geometry: new Point(m),
							});
							/* let f= new Feature({
							  geometry: new Point([parseFloat(i.longitude),parseFloat(i.latitude)]),
							}); */
							f.setStyle(
								new Style({
									image: new Icon({
										src: personBlue,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.name ? i.name : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.personL.getSource().addFeature(f);
						}
					}
				} else {
					this.personL.getSource().clear();
				}

			},
			vehicleClick: function(data) { //大屏页面点击场内车辆触发
				this.factoryCarShow = !this.factoryCarShow;
				if (this.factoryCarShow) {
					if (data.type == '自有车辆') {
						for (let i of data.data.zycl) {
							let m = [i.longitude, i.latitude] //coordtranse.wgs84togcj02(i.longitude, i.latitude);
							let f = new Feature({
								geometry: new Point(m),
							});
							/* let f= new Feature({
							  geometry: new Point([parseFloat(i.longitude),parseFloat(i.latitude)]),
							}); */
							f.setStyle(
								new Style({
									image: new Icon({
										src: vehicleRed,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.name ? i.name : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.vehicleL.getSource().addFeature(f);
						}
					} else {
						for (let i of data.data.xgf) {
							let m = [i.longitude, i.latitude] //coordtranse.wgs84togcj02(i.longitude, i.latitude);
							let f = new Feature({
								geometry: new Point(m),
							});
							/* let f= new Feature({
							  geometry: new Point([parseFloat(i.longitude),parseFloat(i.latitude)]),
							}); */
							f.setStyle(
								new Style({
									image: new Icon({
										src: vehicleBlue,
										anchor: [0.5, 1]
									}),
									text: new Text({ //文本样式
										text: i.name ? i.name : '',
										fill: new Fill({
											color: '#424242'
										}),
										stroke: new Stroke({
											color: '#fff',
											width: 3
										}),
										offsetY: 10,
										offsetX: 0,
									})
								})
							);
							this.vehicleL.getSource().addFeature(f);
						}
					}
				} else {
					this.vehicleL.getSource().clear();
				}

			},
			checkUserInfoPosition: function(data) {
				if (data) {
					this.checkUserInfoData = data;
					this.userSdnum = 0;
					this.timer2 = setInterval(this.shandongUser, 500);
				}
			},
			shandongUser: function() {
				let data = this.checkUserInfoData;
				if (this.userSdnum % 2 == 1) {
					this.checkUserInfoL.getSource().clear();
				} else {
					for (let i of data) {
						let f = new Feature({
							geometry: new Point([parseFloat(i.lon), parseFloat(i.lat)]),
						});
						let src = this.markers.ffrq;
						f.setStyle(
							new Style({
								image: new Icon({
									src: src,
									anchor: [0.5, 1]
								}),
								text: new Text({ //文本样式
									text: '非法入侵',
									fill: new Fill({
										color: '#424242'
									}),
									stroke: new Stroke({
										color: '#fff',
										width: 3
									}),
									offsetY: 10,
									offsetX: 0,
								})
							})
						);
						this.checkUserInfoL.getSource().addFeature(f);
					}
				}
				this.userSdnum++;
				if (this.userSdnum > 10) {
					clearInterval(this.timer2);
				}
			},
			//检测车辆信息
			checkCarInfoPosition: function(data) {
				if (data) {
					this.checkCarInfoData = data;
					this.carSdnum = 0;
					this.timer1 = setInterval(this.shandongCar, 500);
				}
			},
			shandongCar: function() {
				let data = this.checkCarInfoData;
				if (this.carSdnum % 2 == 1) {
					this.checkCarInfoL.getSource().clear();
				} else {
					for (let i of data) {
						let f = new Feature({
							geometry: new Point([parseFloat(i.longitude), parseFloat(i.latitude)]),
						});
						f.setStyle(
							new Style({
								image: new Icon({
									src: jcCar,
									anchor: [0.5, 1]
								}),
								text: new Text({ //文本样式
									text: i.carCode,
									fill: new Fill({
										color: '#424242'
									}),
									stroke: new Stroke({
										color: '#fff',
										width: 3
									}),
									offsetY: 10,
									offsetX: 0,
								})
							})
						);
						this.checkCarInfoL.getSource().addFeature(f);
					}
				}
				this.carSdnum++;
				if (this.carSdnum > 10) {
					clearInterval(this.timer1);
				}
			},
			monitoringClick: function(data) { //监测预警触发
			},
			LeaderPosition: function(data) {
				this.leaderL.getSource().clear();
				if (data) {
					if (data.latitude && data.longitude) {
						let m = coordtranse.wgs84togcj02(data.longitude, data.latitude);
						let f = new Feature({
							geometry: new Point(m),
						});
						f.setStyle(
							new Style({
								image: new Icon({
									src: leaderMarker,
									anchor: [0.5, 1]
								}),
								text: new Text({ //文本样式
									text: data.name ? data.name : '',
									fill: new Fill({
										color: '#424242'
									}),
									stroke: new Stroke({
										color: '#fff',
										width: 3
									}),
									offsetY: 10,
									offsetX: 0,
								})
							})
						);
						this.leaderL.getSource().addFeature(f);
					}
				}
			}
		},
		watch: {
			highRiskPosition: function(val, oldval) {
				this.riskWorkPosition(val);
				/* this.donghuoL.getSource().clear();
				let f = new Feature(new Point(val.coord));
				this.donghuoL.getSource().addFeature(f); */
			}
		}
	};
</script>
<style scoped>
	#map {
		height: 100%;
		width: 100%;
		position: relative;
	}

	.layer-buttons {
		position: absolute;
		top: 0;
		right: 6px;
		z-index: 2;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 30px;
		background: rgba(0, 28, 88, 0.35);
		padding: 6px 0;
		border-radius: 3px;
	}

	.layer-buttons img {
		margin: 4px auto;
		cursor: pointer;
		display: block;
		width: 16px;
	}
	#overlayinfo {
  padding: 10px 20px;
  border-radius: 4px;
  background-color: white;
  font: 0.5em sans-serif;
  box-shadow: 0px 0px 3px #555;
  position: relative;
  color: #2c3e50;
}

#overlayinfo:before {
  content: "";
  position: absolute;
  right: 42%;
  bottom: -6px;
  width: 0;
  height: 0;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  border-top: 6px solid #fff;
}
	/* @media screen and (max-height: 800px) {
		.layer-buttons {
			bottom: 0;
			top: 1vh;
			right: 8px;
		}
	} */
</style>
